import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tekken",
  "use": "tekken-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tekken\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 6L5.11331 8.74286H13.4813L6.84167 18H9.43823L19.0532 14.0605L19.103 14H14.5478L18.0408 8.62857H22.3258L24 6H0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol